import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const sendCarePlanSmsFn = async ({ reviewId, mobileOverride }) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const axiosInstance = createAxiosInstance();
  // Body is optional server-side: empty {} sends to the patient's registered
  // mobile; the message itself is composed from the care-plan infoLinks on the BE.
  const body = mobileOverride ? { mobileOverride } : {};

  return axiosInstance.post(
    `${tenantVal}/cdm/reviews/${reviewId}/care-plan/send-sms`,
    body
  );
};

export const useSendCarePlanSms = () =>
  useMutation({
    mutationFn: sendCarePlanSmsFn,
    // Surface the BE message (e.g. 409 "Patient has not set SMS as a
    // communication preference") instead of the generic global toast.
    meta: { skipGlobalError: true },
    onSuccess: () => toast.success("Care plan links sent by SMS."),
    onError: (error) =>
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to send care plan links by SMS."
      ),
  });
